export const LOGIN = 'LOGIN';
export const INVITEE_PAGE = 'INVITEE_PAGE';
export const INVITEE_PAGE_SOFT_CLOSING = 'INVITEE_PAGE_SOFT_CLOSING';
export const INVITATION_PAGE = 'INVITATION_PAGE';
export const REFERRAL_DASHBOARD = 'REFERRAL_DASHBOARD';
export const REFERRAL_DASHBOARD_SOFT_CLOSING = 'REFERRAL_DASHBOARD_SOFT_CLOSING';
export const PLATFORM_REGISTRATION = 'PLATFORM_REGISTRATION';
export const ERROR = 'ERROR';
export const ERROR_GENERAL = 'ERROR_GENERAL';
export const ERROR_INELIGIBLE = 'ERROR_INELIGIBLE';
export const ERROR_UBISERVICES_REQUEST = 'ERROR_UBISERVICES_REQUEST';
export const ERROR_CAMPAIGN_STATUS = 'ERROR_CAMPAIGN_STATUS';
export const END_OF_OPERATION = 'END_OF_OPERATION';
export const ERROR_MAINTENANCE = 'ERROR_MAINTENANCE';
